<template>
  <div class="content">
        <div class="build-CURD">
          <div class="build-bar" style="text-align: right;padding-right:5vw;">
            <!-- <span>类型：</span>
            <el-input placeholder="请输入类型" v-model="tableDataName"></el-input>
            <span>描述：</span>
            <el-input placeholder="请输入描述" v-model="tableDataDetail"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button> -->
            <el-button type="primary" class="add-user" @click="addRow()">添加事件</el-button>
          </div>
          <div class="build-table">
            <el-table
              :default-sort="{prop: 'date', order: 'descending'}"
              :data="tableDataEnd"
              style="width: 100%;"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="100">
                <template slot-scope="scope">
                  <a>{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="标签名">
                <template slot-scope="scope">
                  <a>{{ scope.row.name}}</a>
                </template>
              </el-table-column>
              <el-table-column label="数据值">
                <template slot-scope="scope">
                  <span>{{ scope.row.value }}</span>
                </template>
              </el-table-column>
              <el-table-column label="topic">
                <template slot-scope="scope">
                  <span>{{ scope.row.topic }}</span>
                </template>
              </el-table-column>
              <el-table-column label="时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>

              <!-- 新增窗口 -->
              <el-dialog
                :title="dialogTitle"
                :visible.sync="addFormVisible"
                center
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
                width="500px"
              >
                <el-form :model="addForm" ref="addForm" :rules="rules" label-width="100px" :label-position="labelPosition">
                  <el-form-item label="标签名：" prop="name">
                    <el-input v-model="addForm.name" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="数据值：">
                    <el-input v-model="addForm.value" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="topic：">
                    <el-input v-model="addForm.topic" autocomplete="off"></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="addFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
              </el-dialog>
            </el-table>
            <!-- 表单列表 -->
            <!-- <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination> -->
          </div>
        </div>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from "../../../untils/util.js"
import base from '../../../untils/base'
var _index
export default {
  data() {
    return {
      labelPosition: 'right',
      dialogTitle:'',//弹出框标题
      addForm: {
        id:'',
        name:'',
        value:'',
        topic:'',
      },
      addFormVisible: false,
      tableDataName: '',//查询 类型
      tableDataDetail:'',//查询 描述
      tableDataEnd: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      flag: false,
      rules:{
        name: [
          { required: true, message: '请输入相应内容', trigger: 'blur' }
        ],
      },
      dataText:"数据加载中...",
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 搜索数据
    doFilter() {
      this.currentPage = 1
      this.getData();
    },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.currentChangePage()
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val;
    //   this.currentChangePage();
    // },
    // // 监控当前页码
    // currentChangePage(list) {
    //   this.getData();
    // },
    // 获取数据
    getData() {
      var that = this;
      myHttp.getTopicValueList().then(function(resp){
        if(resp.data.code=="200"){
          var list = resp.data.data.aiEquipCameraTopics||[];
            for(var i=0;i<list.length;i++){
              list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
            }
            that.tableDataEnd = list;
            // that.totalItems = resp.data.data.pageInfo.total||0;
            if(that.tableDataEnd.length==0){
              that.dataText = "暂无数据"
            }
        }else{
          that.$message.error(resp.data.msg);
          that.dataText = "暂无数据"
        }
      },function(){});
    },
    // 编辑数据
    handleEdit(index, row) {
      this.addFormVisible = true
      this.dialogTitle = "事件修改"
      this.addForm = {
        id:row.id,
        name:row.name,
        value:row.value,
        topic:row.topic
      }
    },
    // 删除数据
    handleDelete(index, row) {
      var that = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          myHttp.deleteTopic({
            id:row.id
          }).then(function(resp){
            if(resp.data.code=="200"){
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.getData();
            }else{
              that.$message({
                type: 'error',
                message: resp.data.msg
              })
            }
          },function(){});
          this.tableDataBegin.splice(index, 1)
          
        })
        .catch(err => {
          
        })
    },
    // 新增数据
    addRow() {
        this.dialogTitle = "添加事件"
        this.addFormVisible = true
        this.addForm = {
          id:'',
          name:'',
          value:'',
          topic:''
        }
    },
    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(that.addForm.id==""){
            myHttp.createTopic(that.addForm).then(function(resp){
              if(resp.data.code=="200"){
                that.$message.success("添加成功");
                 that.addFormVisible = false;
                 that.currentPage = 1;
                 that.getData();
              }else{
                that.$message.error(resp.data.msg);
              }
            },function(){});
          }else{
            myHttp.updateTopic(that.addForm).then(function(resp){
              if(resp.data.code=="200"){
                that.$message.success("修改成功");
                 that.addFormVisible = false;
                 that.getData();
              }else{
                that.$message.error(resp.data.msg);
              }
            },function(){});
          }
        }
      });
    },
    cancel() {
      this.addFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      
    }
  }
}
</script>

<style>
@import '../../../assets/css/common.css';
</style>

<style scoped>
* {
  box-sizing: border-box;
}
.content{
  height: 100%;
  background: #fff;
}
.build-CURD{
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table{
  height: calc( 100% - 160px );
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.build-table >>> .el-dialog {
 padding-left: 0;
}
</style>